import { useEffect } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { Layout } from '@/components/Layout';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminProducts from '@/pages/admin/Products';
import AdminOrders from '@/pages/admin/Orders';

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    // Meta Pixel ID من environment variables
    const metaPixelId = import.meta.env.VITE_META_PIXEL_ID || '';
    const tiktokPixelId = import.meta.env.VITE_TIKTOK_PIXEL_ID || '';

    // Meta Pixel
    if (metaPixelId) {
      const metaScript = document.createElement('script');
      metaScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(metaScript);

      const metaNoscript = document.createElement('noscript');
      const metaImg = document.createElement('img');
      metaImg.height = 1;
      metaImg.width = 1;
      metaImg.style.display = 'none';
      metaImg.src = `https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1`;
      metaNoscript.appendChild(metaImg);
      document.body.appendChild(metaNoscript);

      console.log('✅ Meta Pixel initialized:', metaPixelId);
    } else {
      console.warn('⚠️ Meta Pixel ID not found. Add VITE_META_PIXEL_ID to .env');
    }

    // TikTok Pixel
    if (tiktokPixelId) {
      const tiktokScript = document.createElement('script');
      tiktokScript.innerHTML = `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
          ttq.load('${tiktokPixelId}');
          ttq.page();
        }(window, document, 'ttq');
      `;
      document.head.appendChild(tiktokScript);

      console.log('✅ TikTok Pixel initialized:', tiktokPixelId);
    } else {
      console.warn('⚠️ TikTok Pixel ID not found. Add VITE_TIKTOK_PIXEL_ID to .env');
    }

    return () => {
      // Cleanup
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Router>
          <Routes>
            {/* صفحة تسجيل دخول الأدمن بدون Layout */}
            <Route path={ROUTE_PATHS.ADMIN_LOGIN} element={<AdminLogin />} />
            
            {/* باقي الصفحات مع Layout */}
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path={ROUTE_PATHS.HOME} element={<Home />} />
                  <Route path={ROUTE_PATHS.PRODUCTS} element={<Products />} />
                  <Route path={ROUTE_PATHS.PRODUCT_DETAIL} element={<ProductDetail />} />
                  <Route path={ROUTE_PATHS.CART} element={<Cart />} />
                  <Route path={ROUTE_PATHS.CHECKOUT} element={<Checkout />} />
                  <Route path={ROUTE_PATHS.LOGIN} element={<Login />} />
                  <Route path={ROUTE_PATHS.REGISTER} element={<Register />} />
                  <Route path={ROUTE_PATHS.ADMIN_DASHBOARD} element={<AdminDashboard />} />
                  <Route path={ROUTE_PATHS.ADMIN_PRODUCTS} element={<AdminProducts />} />
                  <Route path={ROUTE_PATHS.ADMIN_ORDERS} element={<AdminOrders />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </Router>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;